import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const Wrap: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        marginTop: pxToRem(64),
        paddingBottom: pxToRem(190),
    },
});

export const Container: StyleRule = ({ theme }) => ({
    gridGap: pxToRem(32),

    [theme.screen.laptop]: {
        gridGap: pxToRem(50),
    },
});

export const FilterTogglesSection: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        height: pxToRem(59),
    },
});

export const FilterSection: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        paddingTop: pxToRem(59),
    },
});

export const ResultSection: StyleRule = () => ({});
